import type { IconSvgObject } from './types';

const StrokeCenterIcon: IconSvgObject = [
  ["path", { d: "M3 22H21C21.5523 22 22 21.5523 22 21V14C22 13.4477 21.5523 13 21 13H12C11.4477 13 11 12.5523 11 12V3C11 2.44771 10.5523 2 10 2H3C2.44772 2 2 2.44772 2 3V21C2 21.5523 2.44772 22 3 22Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 17.5H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 16.5C10 17.8807 8.88071 19 7.5 19C6.11929 19 5 17.8807 5 16.5C5 15.1193 6.11929 14 7.5 14C8.88071 14 10 15.1193 10 16.5Z", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M6.5 10V2", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default StrokeCenterIcon;
